import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Qrcode from '@/components/Qrcode'
// import TorH5 from '@/components/Torrent-H5'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/test',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/qrcode',
      name: 'Qrcode',
      component: Qrcode
    // },
    // {
    //   path: '/torrent',
    //   name: 'Torrent-H5',
    //   component: TorH5
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js